import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { TwoColumnTextCollapsableBlockViewModel } from './TwoColumnTextCollapsableModule.types';
import { getComponentProps } from '@/utils/vueUtils';

import Plus from '@/assets/icons/plus.svg?inline';
import Minus from '@/assets/icons/minus.svg?inline';
import SizeBreakpoints from '@/common/interfaces/SizeBreakpoints';

const TwoColumnTextCollapsableModuleProps = Vue.extend({
  props: getComponentProps<TwoColumnTextCollapsableBlockViewModel>({
    BackgroundTitle: 'Skillful',
    Title: 'Skilled professionals with extraordinary experience, join them on the bridge anytime.',
    LeftColumnText: `<p>Our pioneering heritage began in challenging polar waters, and since then, we have been steadfastly committed to maintaining the highest safety standards. On National Geographic Explorer, our captains have earned the distinguished title of Ice Master, skills that enable you to go deeper into the ice for a thrilling experience.</p><p>Known as the most experienced and knowledgeable in the industry, our captains create and implement industry standard best practices. They are also vital, engaged members of the expedition community. (In fact, many of our guests treat our open bridges like another lounge, spending hours each day talking with and watching the officers navigate.)</p>`,
    RightColumnText: `<p>Our captains and expedition leaders work in tandem to craft the best itinerary possible. In fact, many expedition leaders and captains have worked together for years, or even decades. They share a common purpose and synergy that most companies simply can’t match. Miles apart from how a typical cruise ship operates, where a captain and cruise director operate independently and follow the same weekly routes, the collaboration between our captains and expedition leaders directly enhances the quality of your experience, as they work around weather, ice conditions, or other challenges to get you out on exploring adventures. And, you’ll find them just as excited as you are about a spectacular whale encounter or a gorgeous sunset.</p>`,
  }),
});

@Component({
  components: {
    Plus,
    Minus,
  },
})
export default class TwoColumnTextCollapsableModule extends TwoColumnTextCollapsableModuleProps {
  @Getter windowSize!: SizeBreakpoints;
  @Getter isInBreakpoint!: (breakpoints: SizeBreakpoints[] | SizeBreakpoints) => boolean;
  ModulePosition: number;
  hidden = true;

  mounted() {
    const module = document.querySelector('.two-column-collapsible-text').getBoundingClientRect();
    this.ModulePosition = module.top + window.pageYOffset;
  }

  toggleFullCopy() {
    this.hidden = !this.hidden;
    if (this.hidden) {
      window.scrollTo({
        top: this.ModulePosition - 65,
        behavior: 'smooth',
      });
    }
  }

  get isHidden() {
    if (this.isInBreakpoint(['md', 'lg'])) return true;
    else {
      return this.hidden;
    }
  }

  get combinedTextFromColumns() {
    const comboText = this.p.LeftColumnText + this.p.RightColumnText;
    return this.isHidden ? comboText.split('</p>')[0].concat('...') + '</p>' : comboText;
  }
}
